import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Grid, Box, IconButton, Tooltip, Backdrop, SpeedDial, SpeedDialAction } from '@mui/material';

// Icons
import TagTwoToneIcon from '@mui/icons-material/TagTwoTone';
import ForumTwoTone from '@mui/icons-material/ForumTwoTone';
import HomeTwoTone from '@mui/icons-material/HomeTwoTone';
import StorefrontTwoTone from '@mui/icons-material/StorefrontTwoTone';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import SpeedTwoTone from '@mui/icons-material/SpeedTwoTone';
import RocketLaunchTwoToneIcon from '@mui/icons-material/RocketLaunchTwoTone'; // New Icon for CTA

// Imports
import MainBanner from './mainbanner';
import About from './about';
import Expo from './ExperiencesSection';
import MiCTa from './MiddleCTA';
import Trip from './SignatureJourneys';
import Testi from './Testimonials';
import Why from './WhyUs';
import Journal from './JournalSection';
import FCTa from './FinalCTA';
import Footer from '../Footer';

const socialActions = [
    { icon: <XIcon />, name: 'X', link: 'https://www.x.com' },
    { icon: <InstagramIcon />, name: 'Instagram', link: 'https://www.instagram.com/Maqtoofficial' },
    { icon: <FacebookIcon />, name: 'Facebook', link: 'https://www.facebook.com/profile.php?id=61561945376958&mibextid=ZbWKwL' },
    { icon: <LinkedInIcon />, name: 'LinkedIn', link: 'https://www.linkedin.com' },
    { icon: <GitHubIcon />, name: 'GitHub', link: 'https://github.com/MaqtoOfficial' },
];

const Index = () => {
    const [showScrollUI, setShowScrollUI] = useState(false);
    const [open, setOpen] = useState(false);
    
    const heroRef = useRef(null);
    const aboutRef = useRef(null);
    const brandsRef = useRef(null);
    const animationRef = useRef(null);
    const servicesRef = useRef(null);
    const timeRef = useRef(null);
    const coraidiRef = useRef(null);
    const testimonialsRef = useRef(null);
    const ctaRef = useRef(null); // ★★★ FIXED: Added a new ref for the CTA button
    const footerRef = useRef(null);

    const pageSections = useMemo(() => [
        { id: 'hero', name: 'Welcome', ref: heroRef, icon: <HomeTwoTone /> },
        { id: 'about', name: 'About Us', ref: aboutRef, icon: <SpeedTwoTone  /> },
        { id: 'brands', name: 'Our Partners', ref: brandsRef, icon: <StorefrontTwoTone /> },
        { id: 'animation', name: 'Our softwear lifestyle', ref: animationRef, icon: <StorefrontTwoTone /> },
        { id: 'services', name: 'Our Services', ref: servicesRef, icon: <StorefrontTwoTone /> },
        { id: 'time', name: 'Our Journey', ref: timeRef, icon: <SpeedTwoTone /> },
        { id: 'testimonials', name: 'Testimonials', ref: testimonialsRef, icon: <SpeedTwoTone /> },
        { id: 'coraidi', name: 'Coraidi ERP', ref: coraidiRef, icon: <SpeedTwoTone /> },
        { id: 'cta', name: 'Get Started', ref: ctaRef, icon: <RocketLaunchTwoToneIcon /> }, // ★★★ FIXED: Added CTA to navigation
        { id: 'footer', name: 'Contact Us', ref: footerRef, icon: <ForumTwoTone /> },
    ], []);


   
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleActionClick = (link) => window.open(link, '_blank');
    const goToContact = () => window.location.href = '/contact';

    return (
        <Grid container spacing={0} justifyContent="center" sx={{ width: "100%", margin: 0, padding: 0, overflowX: 'hidden' }}>
            
            <Grid item xs={12} ref={heroRef} sx={{ mt:5 }}>
                <MainBanner />
            </Grid>
            <Grid item xs={12} ref={aboutRef} sx={{ mt:5 }}>
                <About />
            </Grid>
            <Grid item xs={12}>
                <Expo />
            </Grid>
            <Grid item xs={12}>
                <MiCTa />
            </Grid>
            <Grid item xs={12}>
                <Trip />
            </Grid>
            <Grid item xs={12} sx={{ mt: 4, mb: 4 }}>
                <Testi />
            </Grid>
            <Grid item xs={12}>
                <Journal />
            </Grid>
            <Grid item xs={12} sx={{ mb: 4 }}>
                <FCTa />
            </Grid>
            <Grid item xs={12}>
                <Footer />
            </Grid>
        </Grid>
    );
};

export default Index;